import dayjs, { Dayjs } from 'dayjs';

export const parseDateTime = (
  isoTime: string | undefined,
  format: string = 'DD.MM.YYYY'
): string => {
  if (!isoTime) return '';

  return dayjs(isoTime).format(format);
};

export const getTotalDays = (
  endDate: string,
  startDate: string
): number | null => {
  if (!endDate || !startDate || endDate < startDate) {
    return null;
  }

  const endDateObj = dayjs(endDate);
  const startDateObj = dayjs(startDate);

  const daysDiff = endDateObj.diff(startDateObj, 'days');

  const output = daysDiff + 1;
  return output;
};

export const prepareDatePickerValue = (
  value: string | Dayjs | null,
  startOfDay = false
): string | null => {
  if (!value) {
    return null;
  }

  const time = dayjs(value).tz('UTC');

  if (startOfDay) {
    return time.startOf('day').format();
  }

  const output = time.endOf('day');
  return output.format();
};
